// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"dw-z","summaryPar":"ew-z","ratingCategories":"fw-z","reviewerInfo":"gw-z","reviewTypes":"hw-z","expanded":"iw-z"};